import React from 'react'

const InitApp = () => {
  return <></>
}

export default InitApp